import { authHeader } from "../../../../../helpers/authHeader";
import axios from "axios";


export default {
    loadRequests
};


function loadRequests() {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/masterdata/requests/", requestOptions)
        .then((response) => {
            return response.data.data.requests;
        }, (error) => {
            console.log(error.response);
        });
}





// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MyRequests/api/index.js